import { faqs, company } from '../data/content';
import usePageMeta from '../hooks/usePageMeta';

// Helper function to parse markdown links and return JSX
function parseMarkdownLinks(text) {
  const parts = [];
  const regex = /\[([^\]]+)\]\(([^)]+)\)/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    // Add text before the link
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    // Add the link
    parts.push(
      <a
        key={match.index}
        href={match[2]}
        target="_blank"
        rel="noopener noreferrer"
      >
        {match[1]}
      </a>
    );
    lastIndex = regex.lastIndex;
  }

  // Add remaining text
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts.length > 0 ? parts : text;
}

export default function Support() {
  usePageMeta({
    title: 'Norppa - Tuki',
    description: 'Norppa-sovelluksen asiakastuki. Usein kysytyt kysymykset ja yhteydenotto.',
    canonical: 'https://pulmakivi.fi/tuki',
  });

  return (
    <div>
      <h1 className="page__title">Asiakastuki</h1>
      <p className="page__subtitle">Usein kysytyt kysymykset ja yhteydenotto</p>

      <section className="faq">
        {faqs.map((faq, i) => (
          <div key={i} className="faq__item">
            <h3 className="faq__question">{faq.question}</h3>
            <p className="faq__answer">{parseMarkdownLinks(faq.answer)}</p>
          </div>
        ))}
      </section>

      <section className="contact-form">
        <h2>Ota yhteyttä</h2>

        <p>Lähetä meille sähköpostia osoitteeseen:</p>

        <p className="contact-email">
          <a href={`mailto:${company.email}`}>{company.email}</a>
        </p>

        <div className="contact-instructions">
          <h3>Hyvä sisällyttää viestiin:</h3>
          <ul>
            <li>Tarkka kuvaus ongelmasta tai kysymyksesi</li>
            <li>Norppa-tilisi sähköpostiosoite (jos asia koskee tiliäsi tai tilaustasi)</li>
            <li>Mahdolliset kuvakaappaukset tai virheilmoitukset</li>
          </ul>
        </div>
      </section>
    </div>
  );
}
